import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FilterIbanFormContext } from './filter-iban.types';
import { FormCheckbox, LwFormInput } from '../../../../../redesign';

export const FilterIban = () => {
  const { watch, control } = useFormContext<FilterIbanFormContext>();
  const allowIbanFilter = watch('allowIbanFilter');
  return (
    <>
      <Box>
        <FormCheckbox
          name="allowIbanFilter"
          control={control}
          label="IBAN"
          isHeaderCheckbox={true}
        />
      </Box>
      {allowIbanFilter ? (
        <Box paddingLeft="30px">
          <LwFormInput
            name="iban"
            label="IBAN"
            control={control}
            rules={{ required: 'Voer een IBAN in' }}
          />
        </Box>
      ) : null}
    </>
  );
};
